module.exports = __webpack_public_path__ + "img/btn-account-balance-bm.e3111622.png";